import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";

const API_BASE = "https://mediapi.onlinepharmaque.in/api/v1";

const initialForm = {
  pName: "",
  price: "",
  details: "",
  discountPrice: "",
  offerPrice: "",
  pImg: [],
  MaincategoryId: "",
  subcategoryId: "",
  subcategoryName: "",
  MaincategoryName: "",
  size: [],
  color: [],
  rating: "",
  review: [],
  bottomSize: [],
  shoesSize: [],
  availability: "",
  stock: "",

  // ⭐ NEW OPTIONAL FIELDS
  ingredients: "",
  composition: "",
  manufacturer: "",
  pricing: [],
  doses: [],
  review: [],
  ratestar: "",
};

const ProductModal = ({
  proShowModal,
  shoproShowModal,
  editMode = false,
  editedProduct,
  updateProductData,
}) => {
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [formData, setFormData] = useState(initialForm);
  const [imgPreview, setImgPreview] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedPricing, setSelectedPricing] = useState(null);
  const [selectedDoseIndex, setSelectedDoseIndex] = useState(null);
  const [pricingInput, setPricingInput] = useState({
    quantityLabel: "",
    totalPrice: "",
    pricePerUnit: "",
    minQty: "",
  });

  const [doseInput, setDoseInput] = useState("");

  const [reviewInput, setReviewInput] = useState({
    userName: "",
    rating: "",
    comment: "",
  });

  /* ================= FETCH DATA ================= */

  const fetchCategories = async () => {
    const res = await fetch(`${API_BASE}/getallcategory`);
    const data = await res.json();
    setCategories(data.category || []);
  };

  const fetchSubCategories = async () => {
    const res = await fetch(`${API_BASE}/getsubcategory`);
    const data = await res.json();
    setSubCategories(data.result || []);
  };
  const calculateRating = (reviews) => {
    if (!reviews || reviews.length === 0) return "0";

    const total = reviews.reduce(
      (sum, r) => sum + Number(r.rating || r.userstar || 0),
      0,
    );

    return (total / reviews.length).toFixed(1);
  };
  const addReview = () => {
    if (!reviewInput.userName || !reviewInput.rating || !reviewInput.comment) {
      toast.error("Fill all review fields");
      return;
    }

    const newReviews = [
      ...formData.review,
      {
        userName: reviewInput.userName,
        userstar: reviewInput.rating, // backend expects userstar
        comment: reviewInput.comment,
      },
    ];

    setFormData((prev) => ({
      ...prev,
      review: newReviews,
      ratestar: calculateRating(newReviews), // ✅ AUTO CALCULATE
    }));

    setReviewInput({ userName: "", rating: "", comment: "" });
  };

  useEffect(() => {
    fetchCategories();
    fetchSubCategories();
  }, []);

  // ADD DOSE
  const addDose = () => {
    if (!doseInput) return;

    setFormData((prev) => {
      let updatedDoses = [...prev.doses];

      if (selectedDoseIndex !== null) {
        // ✅ UPDATE
        updatedDoses[selectedDoseIndex] = doseInput;
      } else {
        // ✅ ADD
        updatedDoses.push(doseInput);
      }

      return {
        ...prev,
        doses: updatedDoses,
      };
    });

    setDoseInput("");
    setSelectedDoseIndex(null); // reset
  };

  // REMOVE DOSE
  const removeDose = (i) => {
    setFormData((prev) => ({
      ...prev,
      doses: prev.doses.filter((_, index) => index !== i),
    }));
  };

  // ADD PRICING
  const addPricing = () => {
  const { quantityLabel, totalPrice, pricePerUnit, minQty } = pricingInput;

  if (!quantityLabel || !totalPrice || !pricePerUnit || !minQty) {
    toast.error("Fill pricing fields");
    return;
  }

  const newItem = {
    quantityLabel,
    totalPrice: Number(totalPrice),
    pricePerUnit,
    minQty: Number(minQty),
  };

  setFormData((prev) => {
    let updated = [...prev.pricing];

    if (selectedIndex !== null) {
      updated[selectedIndex] = newItem;
    } else {
      updated.push(newItem);
    }

    return { ...prev, pricing: updated };
  });

  setPricingInput({
    quantityLabel: "",
    totalPrice: "",
    pricePerUnit: "",
    minQty: "",
  });

  setSelectedIndex(null);
};

  // REMOVE PRICING
  const removePricing = (i) => {
    setFormData((prev) => ({
      ...prev,
      pricing: prev.pricing.filter((_, index) => index !== i),
    }));
  };
  /* ================= EDIT MODE ================= */

  // useEffect(() => {
  //   if (
  //     editMode &&
  //     editedProduct &&
  //     categories.length > 0 &&
  //     subCategories.length > 0
  //   ) {
  //     console.log("EDIT DATA:", editedProduct);
  //     console.log("CATEGORIES:", categories);

  //     // ✅ CATEGORY MATCH (ONLY BY NAME)
  //     // ✅ FORCE MATCH (fallback)
  //     let matchedCategory = categories.find(
  //       (c) =>
  //         c.MaincategoryName?.toLowerCase().trim() ===
  //         editedProduct.MaincategoryName?.toLowerCase().trim(),
  //     );

  //     // 🔥 अगर match ना मिले तो first category set कर दो (temporary fix)
  //     if (!matchedCategory && categories.length > 0) {
  //       matchedCategory = categories[0];
  //     }

  //     // ✅ SUBCATEGORY MATCH
  //     const matchedSub = subCategories.find(
  //       (s) =>
  //         s.SubCateoryName?.trim().toLowerCase() ===
  //         editedProduct.subcategoryName?.trim().toLowerCase(),
  //     );

  //     setFormData({
  //       ...initialForm,
  //       pName: editedProduct.pName || "",
  //       price: editedProduct.price || "",
  //       details: editedProduct.details || "",
  //       discountPrice: editedProduct.discountPrice || "",
  //       offerPrice: editedProduct.offerPrice || "",

  //       // ✅ FORCE SET ID FROM MATCH
  //       MaincategoryId: matchedCategory?._id || "",
  //       MaincategoryName: matchedCategory?.MaincategoryName || "",

  //       subcategoryId: matchedSub?.id || "",
  //       subcategoryName: matchedSub?.SubCateoryName || "",

  //       rating: editedProduct.rating || "",
  //       review: editedProduct.review || [],
  //       stock: editedProduct.stock || "",
  //       availability: editedProduct.availability || "In Stock",

  //       pricing: editedProduct.pricing || [],
  //       doses: editedProduct.doses || [],

  //       ingredients: editedProduct.ingredients || "",
  //       composition: editedProduct.composition || "",
  //       manufacturer: editedProduct.manufacturer || "",
  //       indication: editedProduct.indication || "",
  //       pack: editedProduct.pack || "",
  //       dosageform: editedProduct.dosageform || "",
  //     });

  //     // IMAGE
  //     if (editedProduct.pImg) {
  //       setImgPreview(
  //         editedProduct.pImg.map(
  //           (img) => `https://napi.onlinepharmaque.in/uploads/${img}`,
  //         ),
  //       );
  //     }
  //   }
  // }, [editMode, editedProduct, categories, subCategories]);

  useEffect(() => {
    if (
      editMode &&
      editedProduct &&
      categories.length > 0 &&
      subCategories.length > 0
    ) {
      const matchedCategory =
        categories.find(
          (c) =>
            c.MaincategoryName?.toLowerCase().trim() ===
            editedProduct.MaincategoryName?.toLowerCase().trim(),
        ) || categories[0];

      const matchedSub = subCategories.find(
        (s) =>
          s.SubCateoryName?.toLowerCase().trim() ===
          editedProduct.subcategoryName?.toLowerCase().trim(),
      );

      const pricingData = editedProduct.pricing || [];

      setFormData({
        ...initialForm,

        pName: editedProduct.pName || "",
        price: editedProduct.price || "",
        details: editedProduct.details || "",
        discountPrice: editedProduct.discountPrice || "",
        offerPrice: editedProduct.offerPrice || "",

        MaincategoryId: matchedCategory?._id || "",
        MaincategoryName: matchedCategory?.MaincategoryName || "",

        subcategoryId: matchedSub?.id || "",
        subcategoryName: matchedSub?.SubCateoryName || "",

        rating: editedProduct.rating || "",
        review: editedProduct.review || [],
        stock: editedProduct.stock || "",
        availability: editedProduct.availability || "In Stock",
ratestar:editedProduct.ratestar,
        pricing: pricingData,
        doses: editedProduct.doses || [],

        ingredients: editedProduct.ingredients || "",
        composition: editedProduct.composition || "",
        manufacturer: editedProduct.manufacturer || "",
        indication: editedProduct.indication || "",
        pack: editedProduct.pack || "",
        dosageform: editedProduct.dosageform || "",
      });

      // ✅ AUTO FILL PRICING INPUT (MAIN FIX)
      if (pricingData.length > 0) {
        setPricingInput({
          quantityLabel: pricingData[0].quantityLabel || "",
          totalPrice: pricingData[0].totalPrice || "",
          pricePerUnit: pricingData[0].pricePerUnit || "",
          minQty: pricingData[0].minQty || "",
        });

        setSelectedIndex(0);
      }

      // IMAGE
      if (editedProduct.pImg) {
        setImgPreview(
          editedProduct.pImg.map(
            (img) => `https://mediapi.onlinepharmaque.in/uploads/${img}`,
          ),
        );
      }
    }
  }, [editMode, editedProduct, categories, subCategories]);

  
  /* ================= HANDLERS ================= */

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // const handleImageChange = (e) => {
  //     setFormData({ ...formData, pImg: e.target.files });
  // };
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);

    setFormData({ ...formData, pImg: files });

    const previews = files.map((file) => URL.createObjectURL(file));
    setImgPreview(previews);
  };

  const handleSubCategoryChange = (e) => {
    const subcategoryId = e.target.value;

    const selected = subCategories.find((s) => s.id === subcategoryId);

    setFormData((prev) => ({
      ...prev,
      subcategoryId: selected?.id || "",
      subcategoryName: selected?.SubCateoryName || "",
    }));
  };

  /* ================= REVIEW ================= */

  const removeReview = (i) => {
    const updated = formData.review.filter((_, index) => index !== i);

    setFormData((prev) => ({
      ...prev,
      review: updated,
      ratestar: calculateRating(updated), // ✅ UPDATE
    }));
  };

  /* ================= FORM DATA ================= */

  const prepareFormData = () => {
    const fd = new FormData();

    fd.append("pName", formData.pName);
    fd.append("price", formData.price);
    fd.append("details", formData.details);
    fd.append("subcategoryId", formData.subcategoryId);
    fd.append("subcategoryName", formData.subcategoryName);
    fd.append("MaincategoryName", formData.MaincategoryName);
    fd.append("rating", formData.rating);
    fd.append("availability", formData.availability);
    fd.append("stock", Number(formData.stock)); // ✅ IMPORTANT

    // ⭐ NEW OPTIONAL FIELDS
    fd.append("ingredients", formData.ingredients);
    fd.append("composition", formData.composition);
    fd.append("dosageform", formData.dosageform);
    fd.append("indication", formData.indication);
    fd.append("pack", formData.pack);
    fd.append("manufacturer", formData.manufacturer);
    fd.append("review", JSON.stringify(formData.review));
    fd.append("ratestar", formData.ratestar); // ✅ MUST

    fd.append("pricing", JSON.stringify(formData.pricing));
    fd.append("doses", JSON.stringify(formData.doses));

    if (formData.discountPrice) {
      fd.append("discountPrice", formData.discountPrice);
    }

    if (formData.offerPrice) {
      fd.append("offerPrice", formData.offerPrice);
    }

    for (let i = 0; i < formData.pImg.length; i++) {
      fd.append("pImg", formData.pImg[i]);
    }

    // fd.append("review", JSON.stringify(formData.review));

    return fd;
  };

  /* ================= SUBMIT ================= */

  const handleSubmit = async () => {
    try {
      const url = editMode
        ? `${API_BASE}/updateproduct/${editedProduct._id}`
        : `${API_BASE}/addProduct/${formData.subcategoryId}`;

      const method = editMode ? "patch" : "post";

      const res = await axios[method](url, prepareFormData(), {
        headers: { "Content-Type": "multipart/form-data" },
      });

      updateProductData((prev) =>
        editMode
          ? prev.map((p) =>
              p._id === res.data.result._id ? res.data.result : p,
            )
          : [res.data.result, ...prev],
      );

      toast.success(editMode ? "Product Updated" : "Product Added");
      shoproShowModal(false);
      setFormData(initialForm);
    } catch (err) {
      toast.error("Something went wrong");
    }
  };

  const removeImage = (index) => {
    const newImg = [...formData.pImg];
    const newPreview = [...imgPreview];

    newImg.splice(index, 1);
    newPreview.splice(index, 1);

    setFormData({ ...formData, pImg: newImg });
    setImgPreview(newPreview);
  };

  if (!proShowModal) return null;

  const deletePricing = (index) => {
    const updated = formData.pricing.filter((_, i) => i !== index);

    setFormData({
      ...formData,
      pricing: updated,
    });

    // reset selection agar wahi delete hua ho
    if (selectedIndex === index) {
      setSelectedIndex(null);
      setSelectedPricing(null);
      setPricingInput({
        quantityLabel: "",
        totalPrice: "",
        pricePerUnit: "",
        minQty: "",
      });
    }
  };

  /* ================= UI ================= */

  return (
    <>
      {/* BACKDROP */}
      <div className="fixed inset-0 bg-black/70 z-40"></div>

      {/* MODAL */}
      <div className="fixed inset-0 z-50 flex items-center justify-center px-4 bg-black/60">
        <div className="w-full max-w-5xl bg-[#0f172a] rounded-2xl shadow-2xl border border-gray-700 flex flex-col">
          {/* ================= HEADER ================= */}
          <div className="flex justify-between items-center px-6 py-4 border-b border-gray-700">
            <h2 className="text-xl font-semibold text-white">
              {editMode ? "Edit Product" : "Add Product"}
            </h2>
            <button
              onClick={shoproShowModal}
              className="text-gray-400 hover:text-white text-2xl"
            >
              ✕
            </button>
          </div>

          {/* ================= BODY (SCROLLABLE) ================= */}
          <div className="p-6 max-h-[75vh] overflow-y-auto">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {/* CATEGORY */}
              <div>
                <label className="text-sm text-gray-400">Category</label>
                <select
                  value={formData.MaincategoryId || ""}
                  onChange={(e) => {
                    const selected = categories.find(
                      (c) => c._id === e.target.value,
                    );

                    setFormData({
                      ...formData,
                      MaincategoryId: selected?._id || "",
                      MaincategoryName: selected?.MaincategoryName || "",
                    });
                  }}
                  className="w-full mt-1 bg-[#020617] border border-gray-700 rounded-lg px-4 py-2 text-white"
                >
                  <option value="">Select Category</option>
                  {categories.map((c) => (
                    <option key={c._id} value={c._id}>
                      {c.MaincategoryName}
                    </option>
                  ))}
                </select>
              </div>

              {/* SUB CATEGORY */}
              <div>
                <label className="text-sm text-gray-400">Sub Category</label>
                <select
                  value={formData.subcategoryId || ""}
                  onChange={handleSubCategoryChange}
                  className="w-full mt-1 bg-[#020617] border border-gray-700 rounded-lg px-4 py-2 text-white"
                >
                  <option value="">Select SubCategory</option>
                  {subCategories.map((s) => (
                    <option key={s.id} value={s.id}>
                      {s.SubCateoryName}
                    </option>
                  ))}
                </select>
              </div>

              {/* PRODUCT NAME */}
              <div>
                <label className="text-sm text-gray-400">Product Name</label>
                <input
                  name="pName"
                  value={formData.pName || ""}
                  onChange={handleChange}
                  className="w-full mt-1 bg-[#020617] border border-gray-700 rounded-lg px-4 py-2 text-white"
                  placeholder="Enter product name"
                />
              </div>

           

              {/* PRICE */}
               <div>
                <label className="text-sm text-gray-400">Price</label>
                <input
                  type="number"
                  name="price"
                  value={formData.price}
                  onChange={handleChange}
                  className="w-full mt-1 bg-[#020617] border border-gray-700 rounded-lg px-4 py-2 text-white"
                  placeholder="₹ Price"
                />
              </div>

              {/* DISCOUNT */}
              <div>
                <label className="text-sm text-gray-400">Discount Price</label>
                <input
                  type="number"
                  name="discountPrice"
                  value={formData.discountPrice || ""}
                  onChange={handleChange}
                  className="w-full mt-1 bg-[#020617] border border-gray-700 rounded-lg px-4 py-2 text-white"
                  placeholder="₹ Discount"
                />
              </div>

              {/* IMAGES */}
              <div className="flex gap-4 items-start">
                {/* FILE INPUT */}
                <div className="w-1/2">
                  <label className="text-sm text-gray-400">
                    Product Images
                  </label>
                  <input
                    type="file"
                    multiple
                    onChange={handleImageChange}
                    className="w-full mt-1 text-sm text-gray-300 bg-[#020617] border border-gray-700 rounded-lg px-3 py-2"
                  />
                </div>

                {/* IMAGE PREVIEW */}
                {imgPreview.length > 0 && (
                  <div className="w-1/2 flex gap-3 flex-wrap mt-6">
                    {imgPreview.map((src, i) => (
                      <div key={i} className="relative">
                        <img
                          src={src}
                          alt="preview"
                          className="w-20 h-20 object-cover rounded-lg border border-gray-700"
                        />
                        <button
                          onClick={() => removeImage(i)}
                          className="absolute -top-2 -right-2 bg-red-600 text-white rounded-full text-xs px-1"
                        >
                          ✕
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* DETAILS */}
              <div className="md:col-span-2">
                <label className="text-sm text-gray-400">Description</label>
                <textarea
                  rows="3"
                  name="details"
                  value={formData.details || ""}
                  onChange={handleChange}
                  className="w-full mt-1 bg-[#020617] border border-gray-700 rounded-lg px-4 py-2 text-white"
                />
              </div>
              {/* AVAILABILITY */}
              <div>
                <label className="text-sm text-gray-400 mb-2 block">
                  Availability
                </label>
                <div className="flex gap-3">
                  <button
                    type="button"
                    onClick={() =>
                      setFormData({ ...formData, availability: "In Stock" })
                    }
                    className={`flex-1 px-4 py-2 rounded-lg border ${
                      formData.availability === "In Stock"
                        ? "bg-green-600 border-green-500 text-white"
                        : "border-gray-700 text-gray-400"
                    }`}
                  >
                    In Stock
                  </button>

                  <button
                    type="button"
                    onClick={() =>
                      setFormData({ ...formData, availability: "Out of Stock" })
                    }
                    className={`flex-1 px-4 py-2 rounded-lg border ${
                      formData.availability === "Out of Stock"
                        ? "bg-red-600 border-red-500 text-white"
                        : "border-gray-700 text-gray-400"
                    }`}
                  >
                    Out of Stock
                  </button>
                </div>
              </div>
              {/* STOCK */}
              <div>
                <label className="text-sm text-gray-400">Stock Quantity</label>
                <input
                  type="number"
                  min="0"
                  name="stock"
                  value={formData.stock || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      stock: e.target.value,
                      availability:
                        e.target.value === "0" ? "Out of Stock" : "In Stock",
                    })
                  }
                  className="w-full mt-1 bg-[#020617] border border-gray-700 rounded-lg px-4 py-2 text-white"
                />
              </div>
              {/* ingredients / composition / MANUFACTURER */}
              

              {/* ================= REVIEW + RATING ================= */}
              {/* ================= REVIEW + RATING ================= */}
              <div className="md:col-span-3 grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* 🔹 REVIEW SECTION */}
                <div className="bg-[#020617] p-4 rounded-lg border border-gray-700">
                  <label className="text-sm text-gray-400 font-semibold">
                    Add Review
                  </label>

                  {/* INPUTS */}
                  <div className="flex flex-col gap-2 mt-3">
                    <input
                      placeholder="User Name"
                      value={reviewInput.userName}
                      onChange={(e) =>
                        setReviewInput({
                          ...reviewInput,
                          userName: e.target.value,
                        })
                      }
                      className="bg-[#0f172a] border px-3 py-2 text-white rounded"
                    />

                    <input
                      type="number"
                      placeholder="Rating (1-5)"
                      value={reviewInput.rating}
                      onChange={(e) =>
                        setReviewInput({
                          ...reviewInput,
                          rating: e.target.value,
                        })
                      }
                      className="bg-[#0f172a] border px-3 py-2 text-white rounded"
                    />

                    <input
                      placeholder="Comment"
                      value={reviewInput.comment}
                      onChange={(e) =>
                        setReviewInput({
                          ...reviewInput,
                          comment: e.target.value,
                        })
                      }
                      className="bg-[#0f172a] border px-3 py-2 text-white rounded"
                    />
                  </div>

                  {/* ADD BUTTON */}
                  <button
                    onClick={addReview}
                    className="mt-3 w-full bg-green-600 hover:bg-green-700 py-2 rounded text-white"
                  >
                    Add Review
                  </button>

                  {/* REVIEW LIST */}
                  <div className="mt-4 space-y-2 max-h-40 overflow-y-auto">
                    {formData.review.map((r, i) => (
                      <div
                        key={i}
                        className="bg-gray-800 px-3 py-2 rounded flex justify-between items-center"
                      >
                        <div>
                          <p className="text-white text-sm">
                            {r.userName} ⭐ {r.userstar || r.rating}
                          </p>
                          <p className="text-gray-400 text-xs">{r.comment}</p>
                        </div>

                        <button
                          onClick={() => removeReview(i)}
                          className="text-red-400"
                        >
                          ✕
                        </button>
                      </div>
                    ))}
                  </div>
                </div>

                {/* 🔹 OVERALL RATING */}
                <div className="bg-[#020617] p-4 rounded-lg border border-gray-700 flex flex-col justify-center">
                  <label className="text-sm text-gray-400 font-semibold mb-2">
                    Overall Rating
                  </label>

                  <input
                    type="number"
                    step="0.1"
                    placeholder="e.g. 4.5"
                    value={formData.ratestar || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, ratestar: e.target.value })
                    }
                    className="w-full bg-[#0f172a] border border-gray-700 rounded-lg px-4 py-2 text-white"
                  />

                  <p className="text-xs text-gray-500 mt-2">
                    You can set rating manually (no auto calculation)
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* ================= FOOTER ================= */}
          <div className="flex justify-end gap-3 px-6 py-4 border-t border-gray-700">
            <button
              onClick={shoproShowModal}
              className="px-5 py-2 bg-red-500 hover:bg-red-600 rounded-lg text-white"
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              className="px-5 py-2 bg-green-600 hover:bg-green-700 rounded-lg text-white"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductModal;
